<script setup>
import {usePage} from "@inertiajs/vue3";
import CLink from "@/Components/CLink.vue";
import CcategoryButton from "@/Layouts/Parts/CCategoryButton.vue";

const page = usePage()
const categoriesTextColor = portalOptions.categoriesTextColor
</script>

<template>
    <v-app-bar height="85" flat scroll-behavior="hide" scroll-threshold="1" color="secondary" class="category-nav-bar">
        <v-row>
            <v-col md="12" class="d-flex justify-center">
                <v-sheet max-width="100vw" color="secondary">
                    <v-slide-group class="pa-4" selected-class="bg-success" show-arrows>
                        <v-slide-group-item v-for="(category, index) in page.props.categories" :key="index"
                                            v-slot="{ isSelected, toggle, selectedClass }">
                            <c-link :preserve-state="false" :href="route('product.category', {'category': category})">
                                <ccategory-button :category="category" :categoriesTextColor="categoriesTextColor"/>
                            </c-link>
                        </v-slide-group-item>
                        <v-slide-group-item v-slot="{ isSelected, toggle, selectedClass }">
                            <c-link :preserve-state="false" :href="route('product.list')">
                                <v-hover v-slot="{ isHovering, props }">
                                    <div
                                        class="d-flex flex-column align-center rounded pa-4"
                                        :style="{ filter: isHovering ? 'brightness(80%)' : 'none' }"
                                        v-bind="props"
                                    >
                                        <v-img
                                            v-if="page.props.categoryAllIconUrl"
                                            :src="page.props.categoryAllIconUrl"
                                            height="35px"
                                            width="40px"
                                            class="mb-2"
                                        />
                                        <span class="font-weight-bold"
                                              :style="'color: '+ categoriesTextColor+ '!important'">Todos</span>
                                    </div>
                                </v-hover>
                            </c-link>
                        </v-slide-group-item>
                    </v-slide-group>
                </v-sheet>
            </v-col>
        </v-row>
    </v-app-bar>
</template>

<style scoped>
/* Garantir que a barra de categorias fique abaixo do menu normal */
.category-nav-bar {
    position: relative !important;
    z-index: 1 !important;
    top: 0 !important;
}
</style>